export default "__VITE_ASSET__Cwyy$VMH__"